import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PublishingEvent } from '../../../domain/publishing-status';

@Component({
  selector: 'evrideo-publishing-grid',
  templateUrl: './publishing-grid.component.html',
  styleUrls: ['./publishing-grid.component.scss'],
})
export class PublishingGridComponent {
  @Input() events: PublishingEvent[] = [];
  @Input() selectedIds: ReadonlySet<string> = new Set();
  @Input() selectionDisabled = false;

  @Output() selectionChange = new EventEmitter<{ id: string; selected: boolean }>();
  @Output() cancelled = new EventEmitter<void>();

  isSelected(id: string): boolean {
    return this.selectedIds.has(id);
  }

  onSelectionChange(event: PublishingEvent, selected: boolean): void {
    this.selectionChange.emit({ id: event.id, selected });
  }

  onCancelled(): void {
    this.cancelled.emit();
  }
}
